/** Detect Web Speech API availability (Chrome, Android WebView, Safari). */
export function getSpeechRecognitionCtor() {
  if (typeof window === "undefined") return null;
  return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}

export function isSpeechRecognitionSupported() {
  return Boolean(getSpeechRecognitionCtor());
}

/** Heuristic: Android WebView often lacks speech unless Chrome-based with flags enabled. */
export function isAndroidWebView() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /Android/i.test(ua) && /wv|WebView/i.test(ua);
}

export function isAndroidDevice() {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}

export function getSpeechUnsupportedMessage() {
  if (isAndroidWebView()) {
    return "Voice input is not available in this app view. Ask your admin to enable microphone & speech in the WebView, or use Chrome. You can still add enquiries manually.";
  }
  if (isAndroidDevice()) {
    return "Voice input needs Chrome with microphone permission. You can still add enquiries manually.";
  }
  return "Voice input is not supported in this browser. Please use Chrome, Edge, or Safari, or add the enquiry manually.";
}
